import { AppState } from "@pmis3/data-access";
import { VesselMovementState, VesselMovementStateStatus } from "../reducer/vesselMovement.reducer";
import { createSelector } from "@ngrx/store";

export const vesselMovementState = (state: AppState) => state.vesselMovementState;

export const selectVesselMovements = createSelector(
    vesselMovementState,
    (state: VesselMovementState) => {
        console.log("state: ", state)
        return state.status === VesselMovementStateStatus.SUCCESS ? state.vesselMovements?.items : [];
    }
)

export const selectVesselMovementStateStatus = createSelector(
  vesselMovementState,
  (state: VesselMovementState) => state.status
)